// @flow
import { createAction } from 'redux-actions';

type RequestContentPayload = {
  token: string,
  observationsMap: Map<string, *>,
};
export const requestContent = createAction(
  'MODERATE_CONTENT_REQUEST',
  (payload: RequestContentPayload) => payload
);

type ReceiveContentPayload = {
  ugc_id: UgcId,
};

export const receiveContent = createAction(
  'MODERATE_CONTENT_RESPONSE',
  (payload: ReceiveContentPayload) => payload
);

export const updateCurrentUgcId = createAction(
  'UPDATE_CURRENT_UGC_ID',
  (payload: UgcId) => payload
);

export const receivePreviousUgcIdUpdate = createAction(
  'RECEIVE_PREVIOUS_UGC_ID_UPDATE',
  (payload: UgcId) => payload
);

export const requestPreviousUgcIdUpdate = createAction(
  'REQUEST_PREVIOUS_UGC_ID_UPDATE'
);



// WEBPACK FOOTER //
// ./src/pages/moderation/moderate/moderateActions.js